import actionsMagazineList from '@/store/modules/actions-magazine/actions-magazine-list'
import actionsMagazineEdit from '@/store/modules/actions-magazine/actions-magazine-edit'

export default {
  actionsMagazineList,
  actionsMagazineEdit,
}
